import React from 'react';
import { SimpleFooter } from '../../footer/Footer';
import { AdminHeader } from '../plans/AdminHeader';
import { ScoresUsersSection } from './ScoresUsersSection';
/**
 * Creado por Equilibrio Agency 2022<br>
 * Página para mostrar contenido de sección usuarios
 * @return {HTMLElement} Elementos HTML de cada componente
 * @interface AdminHeader
 */
export const ScoresUsersPage = () => {
  return (
    <>
      <AdminHeader />
      <div style={{ marginTop: '100px' }}></div>
      <ScoresUsersSection />
      <SimpleFooter></SimpleFooter>
    </>
  );
};
